










import {Prop, Vue, Component} from "vue-property-decorator";
import FormQuestion from "@/components/form-question.vue";

@Component({
    components: {FormQuestion}
}) export default class extends Vue {
    @Prop() data;
    @Prop({default: 16}) margin;
    @Prop({default: () => window}) scrollEl;
    showErrors = false;

    mounted() {
    }

    setShowErrors(val) {
        this.showErrors = val;
    }

    get formClass() {
        let str = '';

        str += `content-margin-${this.margin}`;

        if(this.showErrors) str += ' show-errors';


        return str;
    }

    submit() {
        this.setShowErrors(false);

        let formQuestions: any = this.$refs.formQuestions,
            errors = formQuestions.filter(formQuestion => !formQuestion.getIsValid()),
            response = {};


        if (errors.length) {
            let rect = errors[0].$refs.input.getBoundingClientRect();

            this.scrollEl.scrollTo({
                top: this.scrollEl.scrollTop + rect.top - 24,
                left: 0,
                behavior: 'smooth'
            });

            this.setShowErrors(true);
            return false;
        }

        formQuestions.forEach((formQuestion) => {
            response[formQuestion.data.key] = formQuestion.getValue();
        });

        return response;
    }

}
